import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useFormContext } from 'react-hook-form';
import { Checkbox, ListItemText } from '@mui/material';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, schedules, theme) {
    return {
        fontWeight:
            schedules.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

export default function MultipleSelectPlaceholder({
    name, label = 'label', opt = [], labelWithin = 'label within',
    shortlabel = 'shortlabel', valueKey = '', idKey = '', limit = false, placeholder = 'placeholder'
}) {
    // const extractor = () => { // make another extractor if needed, 
    //     let
    //         days = opt.map((x, i) => x.day),
    //         from = opt.map((x, i) => x.from),
    //         to = opt.map((x, i) => x.to),
    //         id = opt.map((x, i) => x.id);
    //     return { days, from, to, id, }
    // }

    const { watch, trigger, setValue } = useFormContext()
    let v = watch(name)

    const [schedules, setSchedules] = React.useState([]);

    React.useEffect(() => {
        if (v) trigger(name)
        // console.log(schedules.map(x => extractor().id[x]), '=======================');
    }, [v, trigger, name])

    React.useEffect(() => {
        setValue('schedules', schedules)
    }, [schedules, setValue])

    const theme = useTheme();
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSchedules(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <label htmlFor={name} className="text-secondary text-sm inline-block mb-3">{label}</label>
            <FormControl sx={{ width: '100%', border: 'none !important' }}>
                <Select
                    multiple
                    displayEmpty
                    value={schedules}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    style={{ border: 'none !important' }}
                    renderValue={(selected) => {
                        if (selected.length === 0) {
                            return <span style={{ color: '#05213D' }}>{placeholder}</span>;
                        }
                        return <span style={{ fontSize: '12px' }}>{selected.map(x => {
                            return opt.find(y => x === y.value)?.label
                        })}</span>
                    }}
                    MenuProps={MenuProps}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled value="">
                        <em style={{ color: '#05213D' }}>{opt.length ? placeholder : 'No options created'}</em>
                    </MenuItem>
                    {opt.map(({ label, value }, i) => {

                        const checked = (schedules?.find(schedule => schedule === value)) || null

                        return (<MenuItem
                            key={value}
                            value={value}
                            style={getStyles(i, schedules, theme)}
                        >
                            <ListItemText primary={label} />
                            <Checkbox checked={checked} />
                        </MenuItem>)

                    })}
                </Select>
            </FormControl>
        </div>
    );
}
